// extracted by mini-css-extract-plugin
module.exports = {"head":"head-268CC","header":"header-1TE6k","description":"description-ikM5s"};